import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Loader2, AlertCircle } from 'lucide-react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { connectProviderAccount } from '../lib/mercadopago';
import { updateProviderProfile } from '../lib/persistence';
export function MpConnectCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMsg, setErrorMsg] = useState('');
  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    if (!code || !state) {
      setStatus('error');
      setErrorMsg('Faltan parámetros de autorización.');
      return;
    }
    // Simulamos el proceso de backend
    const processAuth = async () => {
      try {
        // BACKEND REQUIRED: En producción, enviamos el code al backend
        const result = await connectProviderAccount(code, state);
        // Actualizamos el perfil local
        updateProviderProfile({
          mp_connected: true,
          mp_user_id: result.mp_user_id
        });
        setStatus('success');
      } catch (err: any) {
        setStatus('error');
        setErrorMsg(err.message || 'Error al conectar la cuenta.');
      }
    };
    processAuth();
  }, [searchParams]);
  return <Layout data-id="element-521">
      <div className="max-w-md mx-auto px-4 py-20 text-center" data-id="element-522">
        {status === 'loading' && <div className="flex flex-col items-center" data-id="element-523">
            <Loader2 className="w-12 h-12 text-blue-600 animate-spin mb-6" data-id="element-524" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-525">
              Conectando cuenta...
            </h1>
            <p className="text-gray-500" data-id="element-526">
              Estamos vinculando tu cuenta de Mercado Pago de forma segura.
            </p>
          </div>}

        {status === 'success' && <div className="animate-fade-in" data-id="element-527">
            <div className="inline-flex w-20 h-20 bg-green-100 rounded-full items-center justify-center mb-6" data-id="element-528">
              <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-529" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-530">
              ¡Cuenta conectada!
            </h1>
            <p className="text-gray-500 mb-8" data-id="element-531">
              Ya podés recibir pagos directos. Agreexa descontará su comisión
              automáticamente en cada transacción.
            </p>
            <Button fullWidth onClick={() => navigate('/dashboard')} data-id="element-532">
              Ir a mis acuerdos
            </Button>
          </div>}

        {status === 'error' && <div className="animate-fade-in" data-id="element-533">
            <div className="inline-flex w-20 h-20 bg-red-100 rounded-full items-center justify-center mb-6" data-id="element-534">
              <AlertCircle className="w-10 h-10 text-red-600" data-id="element-535" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-536">
              Error de conexión
            </h1>
            <p className="text-gray-500 mb-8" data-id="element-537">{errorMsg}</p>
            <Button fullWidth onClick={() => navigate('/dashboard')} data-id="element-538">
              Volver al inicio
            </Button>
          </div>}
      </div>
    </Layout>;
}